import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NavigationEnd, Router } from "@angular/router";
import { SwalComponent, SwalPartialTargets } from "@toverux/ngx-sweetalert2";
import Swal, { SweetAlertOptions } from "sweetalert2";
import { IAceiteTermoPrivacidade } from "../_shared/aceite-termo-privacidade/aceite-termo-privacidade";
import { AceiteTermoPrivacidadeService } from "../_shared/aceite-termo-privacidade/aceite-termo-privacidade.service";
import { HeaderService } from "../_shared/http/header.service";
import { EnderecoService } from "./../_shared/endereco/endereco.service";
import { Estado } from "./../_shared/endereco/estado";
import { Pessoa } from "./../_shared/pessoa/pessoa";
import { PessoaService } from "./../_shared/pessoa/pessoa.service";
import { SessionService } from "./../_shared/session/session.service";
import { ValidadoresService } from "./../_shared/validadores/validadores.service";

@Component({
  selector: "app-dados-pessoais",
  templateUrl: "./dados-pessoais.component.html",
  styleUrls: ["./dados-pessoais.component.css"],
})
export class DadosPessoaisComponent implements OnInit {
  @ViewChild("popupLGPD")
  public readonly popupLGPD: SwalComponent;
  public configuracoesPopupLGPD: IAceiteTermoPrivacidade;
  public checkPopupLGPD: boolean = false;
  public checkErroPopupLGPD: boolean = false;
  public popupLGPDOptions: SweetAlertOptions = {};

  public pessoa: Pessoa = new Pessoa();
  public formulario: FormGroup;
  public validaFormulario = true;
  public estados: Estado[];

  public pes_nom_placeholder = "Nome completo";
  public pes_nom_classe: string;

  public pes_pass_num_placeholder = "Passaporte";
  public pes_pass_num_classe: string;

  public pes_dat_nas_placeholder = "Data de Nascimento";
  public pes_dat_nas_classe: string;

  public sexo_selecionado = "Sexo";
  public pes_sexo_classe: string;
  public sexos = [
    { id: "2", text: "Feminino" },
    { id: "1", text: "Masculino" },
  ];

  public pes_cpf_placeholder = "CPF";
  public pes_cpf_classe: string;

  public pes_rg_placeholder = "RG - Apenas números";
  public pes_rg_classe: string;

  public pes_rg_org_exp_placeholder = "Org. exp.";
  public pes_rg_org_exp_classe: string;

  public pes_rg_uf_classe: string;

  public pes_mail_placeholder = "e-mail";
  public pes_mail_classe: string;

  public pes_tel_res_placeholder = "Telefone fixo";

  public pes_tel_cel_placeholder = "Celular";
  public pes_tel_cel_classe: string;

  public pes_senha_placeholder = "Senha";
  public pes_senha_classe: string;

  public pes_senha_confirmation: string;
  public pes_senha_confirmation_placeholder = "Confirme sua senha";
  public pes_senha_confirmation_classe: string;

  public estado_selecionado = "UF *";

  public date_mask = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
  public pes_cpf_mask = [
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    ".",
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    ".",
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    "-",
    /[0-9]/,
    /[0-9]/,
  ];
  public pes_tel_cel_mask = [
    "(",
    /[1-9]/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
  public pes_tel_res_mask = [
    "(",
    /[1-9]/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];

  public pes_rne_placeholder = "RNE *";
  public pes_rne_classe: string;

  public pes_pass_dat_val_placeholder = "00/00/0000";
  public pes_pass_dat_val_classe: string;

  public pes_pass_dat_exp_placeholder = "00/00/0000";
  public pes_pass_dat_exp_classe: string;

  public pes_visto_dat_val_placeholder = "00/00/0000";
  public pes_visto_dat_val_classe: string;

  public visto_selecionado = "Tipo do visto";
  public pes_visto_tipo_classe: string;
  public vistos = [
    { id: "1", text: "Definitivo" },
    { id: "2", text: "Temporário" },
  ];

  public pode_editar = true;
  public pode_editar_nom = true;
  public pes_senha_editar = true;
  public pes_cpf_editar = true;

  constructor(
    private router: Router,
    private pessoaService: PessoaService,
    private EnderecoService: EnderecoService,
    private SessionService: SessionService,
    private HeaderService: HeaderService,
    private ValidadoresService: ValidadoresService,
    private AceiteTermoPrivacidadeService: AceiteTermoPrivacidadeService,
    public readonly swalTargets: SwalPartialTargets
  ) {}

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.pessoa = this.pessoaService.getPessoa();
    if (this.pessoa.pes_sobrenome == null) {
      this.pessoa.pes_nom = this.pessoa.pes_nom;
    } else {
      this.pessoa.pes_nom =
        this.pessoa.pes_nom + " " + this.pessoa.pes_sobrenome;
      this.pode_editar_nom = false;
    }

    this.EnderecoService.getEstados("1").subscribe(
      (data) => this.trataCampoUf(data),
      (err) => err
    );

    this.HeaderService.getTokenGnx().subscribe(
      (d) => d,
      (e) => e
    );

    this.podeEditarPessoa();
    this.podeEditarSenha();
    this.podeEditarCpf();
    this.trataSexo();
    this.trataVisto();

    this.chekcMostrarAceitePrivacidade();
  }

  trataCampoUf(data) {
    this.estados = data;

    if (this.pessoa.pes_rg_uf) {
      this.estados.forEach((elemento) => {
        if (
          elemento.uf_sig.toLowerCase() ===
          this.pessoa.pes_rg_uf.toLocaleLowerCase()
        ) {
          this.estado_selecionado = elemento.text;
        }
      });
    }
  }

  trataSexo() {
    if (this.pessoa.pes_sexo) {
      this.sexos.forEach((sexo) => {
        if (sexo.id == this.pessoa.pes_sexo) {
          this.sexo_selecionado = sexo.text;
        }
      });
    }
  }

  trataVisto() {
    if (this.pessoa.pes_visto_tipo) {
      this.vistos.forEach((visto) => {
        if (visto.id == this.pessoa.pes_visto_tipo) {
          this.visto_selecionado = visto.text;
        }
      });
    }
  }

  somenteNumero(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (event.keyCode == "9" || event.keyCode == "8") {
      return true;
    }

    if (!pattern.test(inputChar)) {
      return false;
    }
  }

  mascaraRne(event: any) {
    const pattern = /[a-zA-Z0-9\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (event.keyCode == "9" || event.keyCode == "8") {
      return true;
    }

    if (!pattern.test(inputChar)) {
      return false;
    }
  }

  podeEditarPessoa() {
    if (
      this.isEmptyTrim(this.pessoa.pes_rg) &&
      this.isEmptyTrim(typeof this.pessoa.pes_cpf) &&
      this.isEmptyTrim(this.pessoa.pes_rg_org_exp) &&
      this.isEmptyTrim(this.pessoa.pes_rg_uf)
    ) {
      this.pode_editar = false;
      this.pode_editar_nom = false;
    }
  }

  isEmptyTrim(element) {
    return typeof element == "string" && element.trim() !== "";
  }

  podeEditarSenha() {
    if (!this.pessoa.pes_cod && !this.pessoa.pes_senha) {
      this.pes_senha_editar = true;
    } else {
      this.pes_senha_editar = false;
    }
  }

  podeEditarCpf() {
    if (this.pessoa.pes_pass_num) {
      this.pes_cpf_editar = false;
    } else {
      this.pes_cpf_editar = true;
    }
  }

  removeClaseError() {
    this.pes_senha_classe = "";
    this.pes_cpf_classe = "";
    this.pes_dat_nas_classe = "";
    this.pes_mail_classe = "";
    this.pes_nom_classe = "";
    this.pes_rg_org_exp_classe = "";
    this.pes_rg_classe = "";
    this.pes_senha_confirmation_classe = "";
    this.pes_sexo_classe = "";
    this.pes_rg_uf_classe = "";
  }

  trataFormulario() {
    this.removeClaseError();

    if (this.pes_cpf_editar) {
      this.formulario = new FormGroup({
        pes_nom: new FormControl(this.pessoa.pes_nom, [
          Validators.required,
          Validators.minLength(3),
          //Validators.pattern(/^(((?!_)[A-zÀ-ÿ\-\'\´])[\s]*)+$/gi)
        ]),
        pes_dat_nas: new FormControl(this.pessoa.pes_dat_nas, [
          Validators.required,
          Validators.pattern(
            "^(0?[1-9]|[12][0-9]|3[01])/(0?[1-9]|1[012])/((19|20)\\d\\d)$"
          ),
        ]),
        pes_rg_uf: new FormControl(this.pessoa.pes_rg_uf, Validators.required),
        pes_sexo: new FormControl(this.pessoa.pes_sexo, Validators.required),
        pes_mail: new FormControl(this.pessoa.pes_mail, [
          Validators.required,
          Validators.email,
        ]),
      });

      this.formulario.addControl(
        "pes_rg",
        new FormControl(this.pessoa.pes_rg, [Validators.required])
      );
      this.formulario.addControl(
        "pes_rg_org_exp",
        new FormControl(this.pessoa.pes_rg_org_exp, [Validators.required])
      );
      this.formulario.addControl(
        "pes_rg_uf",
        new FormControl(this.pessoa.pes_rg_uf, [Validators.required])
      );
      this.formulario.addControl(
        "pes_cpf",
        new FormControl(this.pessoa.pes_cpf, [
          Validators.required,
          Validators.minLength(11),
        ])
      );
    } else {
      this.formulario = new FormGroup({
        pes_nom: new FormControl(this.pessoa.pes_nom, [
          Validators.required,
          Validators.minLength(3),
          // Validators.pattern(/^(((?!_)[A-zÀ-ÿ\-\'\´])[\s]*)+$/gi)
        ]),
        pes_dat_nas: new FormControl(this.pessoa.pes_dat_nas, [
          Validators.required,
          Validators.pattern(
            "^(0?[1-9]|[12][0-9]|3[01])/(0?[1-9]|1[012])/((19|20)\\d\\d)$"
          ),
        ]),
        pes_sexo: new FormControl(this.pessoa.pes_sexo, Validators.required),
        pes_mail: new FormControl(this.pessoa.pes_mail, [
          Validators.required,
          Validators.email,
        ]),
      });

      this.formulario.addControl(
        "pes_pass_dat_val",
        new FormControl(this.pessoa.pes_pass_dat_val, [
          Validators.required,
          Validators.pattern(
            "^(0?[1-9]|[12][0-9]|3[01])/(0?[1-9]|1[012])/((19|20)\\d\\d)$"
          ),
        ])
      );
      this.formulario.addControl(
        "pes_pass_dat_exp",
        new FormControl(this.pessoa.pes_pass_dat_exp, [
          Validators.required,
          Validators.pattern(
            "^(0?[1-9]|[12][0-9]|3[01])/(0?[1-9]|1[012])/((19|20)\\d\\d)$"
          ),
        ])
      );
      this.formulario.addControl(
        "pes_visto_dat_val",
        new FormControl(this.pessoa.pes_visto_dat_val, [
          Validators.required,
          Validators.pattern(
            "^(0?[1-9]|[12][0-9]|3[01])/(0?[1-9]|1[012])/((19|20)\\d\\d)$"
          ),
        ])
      );
      this.formulario.addControl(
        "pes_visto_tipo",
        new FormControl(this.pessoa.pes_visto_tipo, [Validators.required])
      );
      this.formulario.addControl(
        "pes_pass_num",
        new FormControl(this.pessoa.pes_pass_num, [
          Validators.required,
          Validators.minLength(5),
        ])
      );
      this.formulario.addControl(
        "pes_rne",
        new FormControl(this.pessoa.pes_rne, [Validators.required])
      );
    }

    this.ValidadoresService.validarEmailNoGX(this.pessoa.pes_mail).subscribe(
      (emailValido) => {
        if (emailValido === "S") {
        } else {
          this.formulario.controls.pes_mail.setErrors({
            ["1"]: "E-mail Inválido",
          });
        }
      },
      (err) => new Error(err)
    );

    if (this.pes_senha_editar) {
      this.formulario.addControl(
        "pes_senha",
        new FormControl(this.pessoa.pes_senha, [
          Validators.required,
          Validators.minLength(4),
        ])
      );
      this.formulario.addControl(
        "pes_senha_confirmation",
        new FormControl(this.pessoa.pes_senha_confirmation, [
          Validators.required,
          Validators.minLength(4),
        ])
      );
    }

    if (!this.pessoa.pes_tel_cel && !this.pessoa.pes_tel_res) {
      this.formulario.addControl(
        "pes_tel_cel",
        new FormControl(this.pessoa.pes_tel_cel, [Validators.required])
      );
    }

    if (this.validaDataMinima(this.pessoa.pes_dat_nas)) {
      this.pessoa.pes_dat_nas = "";
      this.formulario.controls.pes_dat_nas.setErrors({
        ["1"]: "Data está inválida",
      });
    }

    if (this.formulario.status === "INVALID") {
      this.validaFormulario = false;

      this.validForm("pes_nom", "Nome Completo");
      this.validForm("pes_dat_nas", "Data");
      this.validForm("pes_mail", "e-mail");

      if (this.pes_cpf_editar) {
        this.validForm("pes_cpf", "CPF");
        this.validForm("pes_rg", "RG");
        this.validForm("pes_rg_org_exp", "Org. exp.");

        if (!this.formulario.controls.pes_rg_uf.valid) {
          this.pes_rg_uf_classe = "classWarning";
        }
      } else {
        this.validForm("pes_pass_num", "Passaporte");
        this.validForm("pes_pass_dat_val", "Validade");
        this.validForm("pes_pass_dat_exp", "Expedição");
        this.validForm("pes_rne", "RNE");
        this.validForm("pes_visto_dat_val", "Validade");
        this.validForm("pes_visto_tipo", "Tipo do visto");
      }

      if (this.pes_senha_editar) {
        this.validForm("pes_senha", "Senha");
        this.validForm("pes_senha_confirmation", "Confirma Senha");
      }

      if (!this.formulario.controls.pes_sexo.valid) {
        this.sexo_selecionado = "Sexo *";
        this.pes_sexo_classe = "classWarning";
      }

      if (
        this.formulario.controls.pes_tel_cel &&
        !this.formulario.controls.pes_tel_cel.valid
      ) {
        this.pes_tel_cel_placeholder = "Um dos telefones é obrigatório";
        this.pes_tel_cel_classe = "classWarning";
      }

      if (this.pes_senha_editar) {
        if (
          this.formulario.controls.pes_senha.value !==
          this.formulario.controls.pes_senha_confirmation.value
        ) {
          this.pessoa.pes_senha_confirmation = "";
          this.pes_senha_confirmation_classe = "classErro";
          this.pes_senha_confirmation_placeholder = "As senhas não conferem";

          this.pessoa.pes_senha = "";
          this.pes_senha_classe = "classErro";
          this.pes_senha_placeholder = "As senhas não conferem";
        }
      }
    }

    if (this.formulario.status === "VALID") {
      this.validaFormulario = true;
    }

    if (!this.pode_editar) {
      const pessoaEditar = this.pessoaService.getPessoa();
      this.pessoa.pes_rg = pessoaEditar.pes_rg;
      this.pessoa.pes_cpf = pessoaEditar.pes_cpf;
      this.pessoa.pes_rg_org_exp = pessoaEditar.pes_rg_org_exp;
      this.pessoa.pes_rg_uf = pessoaEditar.pes_rg_uf;
    }

    if (this.validaFormulario) {
      this.ValidadoresService.validarEmailNoGX(this.pessoa.pes_mail).subscribe(
        ({ Valido }) => {
          if (Valido === "S") {
            this.pessoaService.salvaPessoa(this.pessoa).subscribe(
              (data) => this.proximo(data),
              (error) => {
                if (error.errors) {
                  this.trataErroWs(error.errors);
                } else {
                  throw new Error();
                }
              }
            );
          } else {
            this.pes_mail_classe = "classErro";
          }
        },
        (err) => new Error(err)
      );
    } else {
      // Formulario Invalido
    }
  }

  validaDataMinima(data) {
    return data && new Date(data).getFullYear() >= new Date().getFullYear();
  }

  selecionaEstado(estado) {
    this.pessoa.pes_rg_uf = estado.text;
    this.pessoa.uf_cod_rg = estado.id;
  }

  selecionaSexo(sexo) {
    this.sexo_selecionado = sexo.text;
    this.pessoa.pes_sexo = sexo.id;
  }

  selecionaVisto(visto) {
    this.visto_selecionado = visto.text;
    this.pessoa.pes_visto_tipo = visto.id;
  }

  proximo(data) {
    if (this.validaFormulario) {
      if (data.pes_cod) {
        this.pessoa.pes_cod = data.pes_cod;
        this.pessoa.pes_cod_comp = data.pes_cod_comp;

        this.pessoaService
          .login(String(this.pessoa.pes_cod), this.pessoa.pes_senha)
          .subscribe((response) => {
            this.pessoa.pes_senha = "";
            this.pessoa.pes_senha_confirmation = "";

            this.SessionService.setValor("token", response.token);

            this.pessoaService.setPessoa(this.pessoa);

            // this.router.navigate(['/inicio']);

            this.HeaderService.getTokenGnx().subscribe(
              (d) => {
                this.pessoaService.atualizaInscricaoIncompleta().subscribe(
                  (d) => {
                    this.AceiteTermoPrivacidadeService.putAceiteUsuario().subscribe(
                      (d) => d,
                      (e) => e
                    );
                    this.router.navigate(["/curso"]);
                  },
                  (err) => err
                );
              },
              (err) => err
            );

            // ANTES DE SALVAR OS LEADS
            //  this.HeaderService
            //     .getTokenGnx()
            //     .subscribe(
            //         d => this.router.navigate(['/curso']),
            //         err => err
            //     );
          });
      } else {
        this.pessoa.pes_senha = "";
        this.pessoa.pes_senha_confirmation = "";

        this.pessoaService.setPessoa(this.pessoa);

        // this.router.navigate(['/inicio']);

        this.HeaderService.getTokenGnx().subscribe(
          (d) => {
            this.AceiteTermoPrivacidadeService.putAceiteUsuario().subscribe(
              (d) => d,
              (e) => e
            );
            this.router.navigate(["/curso"]);
          },
          (err) => err
        );
      }
    }
  }

  trataErroWs(errors) {
    Object.keys(errors).forEach((element) => {
      this[element + "_placeholder"] = errors[element][0];
      this.pessoa[element] = "";
      this[element + "_classe"] = "classErro";
    });
  }

  validForm(campo, nome) {
    if (!this.formulario.controls[campo].valid) {
      this[campo + "_classe"] = "classErro";
      this[campo + "_placeholder"] = nome + " está inválido";

      if (this.formulario.controls[campo].errors["required"]) {
        this[campo + "_classe"] = "classWarning";
        this[campo + "_placeholder"] = nome + " é obrigatório";
      }
    }
  }

  changeSenha() {
    if (this.pessoa.pes_senha.length >= 8) {
      this.pes_senha_classe = "";
    }
  }

  changeConfirmaSenha() {
    if (this.pessoa.pes_senha_confirmation.length >= 8) {
      this.pes_senha_confirmation_classe = "";
    }
  }

  chekcMostrarAceitePrivacidade() {
    this.configuracoesPopupLGPD = new IAceiteTermoPrivacidade();

    this.popupLGPDOptions = {
      width: 500,
      allowEscapeKey: false,
      allowOutsideClick: false,
      title: "Atenção",
      showConfirmButton: false,
      showCancelButton: false,
    };

    this.AceiteTermoPrivacidadeService.getAceiteUsuario().subscribe(
      ({
        isAceitou: aceitouTermoPrivacidade,
        TipAceTexRed: textoReduzido,
        TipAceTexCom: textoCompleto,
        URL: linkPoliticaPrivacidade,
      }) => {
        if (!aceitouTermoPrivacidade) {
          this.configurarAceitePrivacidade(
            textoReduzido,
            textoCompleto,
            linkPoliticaPrivacidade
          );

          this.showAlertAceitePrivacidade();
        }
      },
      (err) => new Error(err)
    );
  }

  confirmarPopupLGPD() {
    if (this.checkPopupLGPD) {
      this.AceiteTermoPrivacidadeService.putSalvarAceiteUsuario();
      Swal.close();
    } else {
      this.checkErroPopupLGPD = true;
    }
  }

  configurarAceitePrivacidade(
    textoReduzido: string,
    textoCompleto: string,
    linkPoliticaPrivacidade: string
  ) {
    this.popupLGPD.showConfirmButton = false;
    this.popupLGPD.showCancelButton = false;
    this.configuracoesPopupLGPD.textoReduzido = textoReduzido;
    this.configuracoesPopupLGPD.textoCompleto = textoCompleto;
    this.configuracoesPopupLGPD.linkPoliticaPrivacidade =
      linkPoliticaPrivacidade;

    this.configuracoesPopupLGPD.textoErroCheckbox =
      "Você precisa concordar com as condições para prosseguir.";
    this.configuracoesPopupLGPD.inputPlaceholder =
      "Eu concordo com estas condições*.";
  }

  showAlertAceitePrivacidade() {
    this.checkPopupLGPD = false;
    this.popupLGPD.show();
  }

  showAlertFinalidades() {
    const textoHTML = `<div style="text-align:left;padding:15px;">${this.configuracoesPopupLGPD.textoCompleto}</div>`;
    const footerHTML = `<a href="${this.configuracoesPopupLGPD.linkPoliticaPrivacidade}" target="_blank" rel="noopener noreferrer">Política de privacidade</a>`;

    Swal({
      width: 800,
      html: textoHTML,
      confirmButtonText: "OK",
      footer: footerHTML,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((dismiss: any) => {
      if (dismiss.value === true) this.showAlertAceitePrivacidade();
    });
  }

  setCheckPopupLGPD() {
    this.checkErroPopupLGPD = false;
    this.checkPopupLGPD = !this.checkPopupLGPD;
  }
}



// WEBPACK FOOTER //
// ./src/app/dados-pessoais/dados-pessoais.component.ts